import { Paper } from "@mui/material";
import { Collections } from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";
import { FormattedMessage } from "react-intl";

import { NodeEnv } from "@dzambalaorg/constants";
import { List } from "@dzambalaorg/ui-kit";

export const PaymentSplitterSection = () => {
  const isProd = process.env.NODE_ENV === NodeEnv.production;

  if (isProd) {
    return null;
  }

  return (
    <Paper sx={{ mb: 2 }}>
      <List
        component="nav"
        subheader={
          <List.Subheader>
            <FormattedMessage id="pages.dashboard.mechanics.payment-splitter" />
          </List.Subheader>
        }
      >
        <List.ItemButton<typeof RouterLink> component={RouterLink} to="/payment-splitter/contracts">
          <List.ItemIcon>
            <Collections />
          </List.ItemIcon>
          <List.ItemText>
            <FormattedMessage id="pages.payment-splitter.contracts.title" />
          </List.ItemText>
        </List.ItemButton>
      </List>
    </Paper>
  );
};
